import React from "react";

import { Icon, IconProps } from "../";

export const MicIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,919 C101.66,919 103,917.66 103,916 L103,910 C103,908.34 101.66,907 100,907 C98.34,907 97,908.34 97,910 L97,916 C97,917.66 98.34,919 100,919 Z M105.91,916 C105.42,916 105.01,916.36 104.93,916.85 C104.52,919.2 102.47,921 100,921 C97.53,921 95.48,919.2 95.07,916.85 C94.99,916.36 94.58,916 94.09,916 C93.48,916 93,916.54 93.09,917.14 C93.58,920.14 95.98,922.49 99,922.92 L99,925 C99,925.55 99.45,926 100,926 C100.55,926 101,925.55 101,925 L101,922.92 C104.02,922.49 106.42,920.14 106.91,917.14 C107.01,916.54 106.52,916 105.91,916 Z"
        transform="translate(-88 -904)"
      />
    </Icon>
  );
};
